
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/przyczepy/[marka]",
      function () {
        return require("private-next-pages/przyczepy/[marka]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/przyczepy/[marka]"])
      });
    }
  